//angular imports
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, enableProdMode, ErrorHandler } from '@angular/core';
import { FormsModule ,ReactiveFormsModule} from '@angular/forms'; //required for 2way databinding
import { RouterModule, Route } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

//3rd party libraries
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgProgressModule } from '@ngx-progressbar/core';
import { NgProgressHttpModule } from '@ngx-progressbar/http'
import { SimpleNotificationsModule } from 'angular2-notifications';
//import { NgxCaptchaModule} from 'ngx-captcha';


//import components + modules
import { AppComponent } from './app.component';
import { ApplicationErrorHandler } from './shared/config/error-handler';

//routes
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { HomeModule } from './home/home.module';
import { SurveyModule} from './survey/survey.module';
import { AdminModule } from './admin/admin.module';




@NgModule({
    declarations: [
        AppComponent,
           ],
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,

        //3rd party modules
        //forRoot() is required in order for NgbModule to be properly setup
        NgbModule.forRoot(),
        SimpleNotificationsModule.forRoot(),
        NgProgressModule.forRoot(),
        NgProgressHttpModule,
        //NgxCaptchaModule,

        //app modules
        SharedModule, //common module + services
        HomeModule,
        AdminModule, 
        SurveyModule,
        AppRoutingModule  //global routing module, except
    ],
    exports: [ ],
    providers: [
        //global error handling + automatic log
        { provide: ErrorHandler, useClass: ApplicationErrorHandler }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
